const state = {
    showModal: false,
    complete: false,
};

const getters = {
};

const actions = {
};

const mutations = {
    setShowModal(state, showModal) {
        state.showModal = showModal;
    },
    setComplete(state, complete) {
        state.complete = complete;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};